import { StorageKeys } from "@/common/constants/storageKeys";
import { Lockr } from "@/common/Lockr";
import { useMessage } from "@/common/messages";
import { ServerEvent } from "@/common/notification";
import { notificationListener } from "@/hooks/notification";
import { InteractionDto } from "@/repository/models";
import { useIntl } from "react-intl";

export const useMessagingTransferManager = () => {
	const { show: showMessage } = useMessage();
	const intl = useIntl();

	notificationListener(
		ServerEvent.ActiveMessagingChanged,
		(interaction: InteractionDto) => {
			if (
				interaction.emailTransferInitiatorId &&
				interaction.emailTransferInitiatorId !== Lockr.get(StorageKeys.UserId)
			) {
				showMessage("workspace", {
					intent: "success",
					text: intl.formatMessage({
						id: "Transfer.ColdTransferPerformedBySupervisor",
					}),
				});
			}
		}
	);
};
